import React, { Component } from 'react'
import { connect } from 'react-redux'

import { ReportePorSilosView } from '../components/ReportePorSilosView'

class ReportePorSilos extends Component {
  render () {
    return <ReportePorSilosView />
  }
}

const withRedux = connect(null, null)

export default withRedux(ReportePorSilos)
